// extracted by mini-css-extract-plugin
export default {"root":"DetailHeader_root__rdwhn","title":"DetailHeader_title__wf5s6","back":"DetailHeader_back__3B6pN","infos":"DetailHeader_infos__1QbqM"};